// extracted by mini-css-extract-plugin
export default {"root":"BellNotificationIcon_root--b_v","hasNotifications":"BellNotificationIcon_hasNotifications--yGS"};